import {
  ChangeDetectionStrategy,
  Component,
  inject,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { FilterOption } from '../../table.interface';
import { SelectComponent } from '../../../select/select.component';
import { TableContext } from '../../../../services/table/table-context.service';

@Component({
  selector: 'app-table-filters',
  templateUrl: './table-filters.component.html',
  styleUrls: ['./table-filters.component.scss'],
  imports: [SelectComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class tableFiltersComponent {
  // -------------------- services ---------------------------------
  tableContext = inject(TableContext);
  // child components
  @ViewChildren(SelectComponent) allFilters!: QueryList<SelectComponent>;

  /**
   * Holds the state of the selected / unselected options
   */

  handleOptionSelected = (option: FilterOption, columnName: string) => {
    const newFilters = {
      ...this.tableContext.filters(),
      [columnName]: this.tableContext
        .filters()
        [columnName].map((opt) =>
          option.id === opt.id
            ? { ...option, checked: true }
            : { ...option, checked: false }
        ),
    };

    this.tableContext.setFilters(newFilters);
    this.tableContext.handleFilterChange([option.value]);
  };

  onlyUnique = (value: any, index: number, array: any[]) => {
    return array.indexOf(value) === index && value !== '';
  };

  trackBy = (filterName: string) => {
    return this.tableContext.name + '-' + filterName;
  };

  handleFilterDataChange = (
    checkedList: string[],
    columnName: string
  ): void => {
    const newFilters = {
      ...this.tableContext.filters(),
      [columnName]: this.tableContext
        .filters()
        [columnName].map((option) =>
          checkedList.includes(option.value)
            ? { ...option, checked: true }
            : { ...option, checked: false }
        ),
    };

    this.tableContext.setFilters(newFilters);

    this.tableContext.handleFilterChange(checkedList);
  };

  getOptions(options: FilterOption[]): string[] {
    return options.map((option) => option.value);
  }

  resetAllFilters = () => {
    console.log('All filters: ', this.allFilters);
    this.allFilters.forEach((filterComponent) => {
      filterComponent.checkOption('', 'all', false);
    });
  };
}
